import React from 'react'

function ServiceTypeTab(): React.ReactElement {
  return <div>...</div>
}

export default ServiceTypeTab
